import React from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { EnterpriseScopeSection } from './components/EnterpriseScopeSection';
import { CompetenciesSection } from './components/CompetenciesSection';
import { CareerTimeline } from './components/CareerTimeline';
import { AchievementsSection } from './components/AchievementsSection';
import { TransformationSection } from './components/TransformationSection';
import { CybersecuritySection } from './components/CybersecuritySection';
import { LeadershipSection } from './components/LeadershipSection';
import { PublicationsSection } from './components/PublicationsSection';
import { BoardAdvisory } from './components/BoardAdvisory';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="circuit-bg min-h-screen text-white font-sans selection:bg-cyan/20 selection:text-cyan-100" data-id="element-0">
      <Navigation data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <EnterpriseScopeSection data-id="element-5" />
        <CompetenciesSection data-id="element-6" />
        <CareerTimeline data-id="element-7" />
        <AchievementsSection data-id="element-8" />
        <TransformationSection data-id="element-9" />
        <CybersecuritySection data-id="element-10" />
        <LeadershipSection data-id="element-11" />
        <PublicationsSection data-id="element-12" />
        <BoardAdvisory data-id="element-13" />
        <ContactSection data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}